import { Box, Button, TableCell, TableRow, Typography } from "@mui/material";
import React, { useState } from "react";
import { ImageContainer } from "../../../../shared/components/ImageContainer";
import { EditIcon, TrashIcon } from "../../../../assets/icons/icons";
import { useNavigate } from "react-router-dom";
import { updateStudioContent } from "../../../../services/studioContent";
import { useGlobalContext } from "../../../../App";
import DeleteDialog from "../../../products/product/DeleteDialog";

interface tableRowProps {
  row: any;
  setIsEditDialogVisible?: any;
}

const Row: React.FC<tableRowProps> = ({ row, setIsEditDialogVisible }) => {
  const { studioContentData } = useGlobalContext();

  const [isDeleteDialogVisible, setIsDeleteDialogVisible] = useState(false);

  const handleEdit = (row: any) => {
    setIsEditDialogVisible(row);
  };
  const handleDeleteTestimonial = async () => {
    const allTestimonials = studioContentData?.testimonials;
    //Exclude this current row from all Testimonials
    const updatedTestimonials = allTestimonials.filter(
      (item: any) => item._id !== row?._id
    );

    //deleting is same as updating in api
    const data = {
      isUpdatingStudioTestimonials: true,
      updatedTestimonials: updatedTestimonials,
      studioContentId: studioContentData?._id,
    };

    await updateStudioContent(data)
      .then((res) => console.log("deleted successfully"))
      .catch((err) => {
        console.log("error deleting project");
      });

    setIsDeleteDialogVisible(false);
  };

  return (
    <TableRow
      onClick={() => {}}
      sx={{
        cursor: "pointer",
        ":hover": {
          bgcolor: "rgba(255, 255, 255, 0.06) !important",
        },
      }}
      hover
      role="checkbox"
      tabIndex={-1}
      key={row?.id}
    >
      {/* Image with name */}
      <TableCell
        sx={{
          // width: "fit-content",
          width: "300px",
          borderBottom: "1px solid rgba(255, 255, 255, 0.06)",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "16px",
          }}
        >
          {row?.userImageUrl && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "60px",
                // height: "72px",
                borderRadius: "100px",
                overflow: "hidden",
                flexShrink: 0,
              }}
            >
              <img
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderRadius: "3px",
                }}
                alt="cover"
                src={row?.userImageUrl}
              />
            </Box>
          )}
          <Typography
            sx={{
              color: "white",
              fontWeight: "300",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
            variant="body2"
          >
            {row?.userName || "-"}
          </Typography>
        </Box>
      </TableCell>

      {/* Position  */}
      <TableCell
        sx={{
          width: "200px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          borderBottom: "1px solid rgba(255, 255, 255, 0.06)",
        }}
      >
        <Typography sx={{ color: "white", fontWeight: "300" }} variant="body2">
          {row?.userDesignation || "-"}
        </Typography>
      </TableCell>

      <TableCell
        sx={{
          width: "200px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          borderBottom: "1px solid rgba(255, 255, 255, 0.06)",
        }}
      >
        <Typography sx={{ color: "white", fontWeight: "300" }} variant="body2">
          {row?.title || "-"}
        </Typography>
      </TableCell>

      {/* description  */}
      <TableCell
        sx={{
          //  width: "400px",
          flex: 1,
          borderBottom: "1px solid rgba(255, 255, 255, 0.06)",
        }}
      >
        <Typography
          sx={{ color: "white", fontWeight: "300", wordBreak: "break-word" }}
          variant="body2"
        >
          {row?.description || "-"}
        </Typography>
      </TableCell>

      {/* Action buttons  */}
      <TableCell
        sx={{
          maxWidth: "80px",
          minWidth: "80px",
          borderBottom: "1px solid rgba(255, 255, 255, 0.06)",
        }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "20px",
          }}
        >
          <Button
            onClick={() => {
              handleEdit(row);
            }}
            sx={{
              minWidth: "0px",
              minHeight: "0px",
              lineHeight: "0px",
              ":hover": {
                bgcolor: "none !important",
              },
            }}
          >
            <ImageContainer
              style={{ width: "24px", height: "24px" }}
              title={"edit"}
            >
              {EditIcon}
            </ImageContainer>
          </Button>

          <Button
            onClick={() => setIsDeleteDialogVisible(true)}
            sx={{
              minWidth: "0px",
              minHeight: "0px",
              lineHeight: "0px",
            }}
          >
            <ImageContainer
              style={{ width: "24px", height: "24px" }}
              title="trash"
            >
              {TrashIcon}
            </ImageContainer>
          </Button>
        </Box>
        {isDeleteDialogVisible && (
          <DeleteDialog
            title="Are you sure you want to delete the testimonial?"
            setIsDeleteDialogVisible={setIsDeleteDialogVisible}
            deleteAction={() => {
              handleDeleteTestimonial();
            }}
          />
        )}
      </TableCell>
    </TableRow>
  );
};

export default Row;
